import apiClient from 'utilities/apiClient';

export const container = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.container}/${url}`, payload, true);
};

export const wastage = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.wastage}/${url}`, payload, true);
};

export const sampling = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.sampling}/${url}`, payload, true);
};

export const Createwastage = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.wastage}/${url}`, payload, true);
};
export const Createsampling = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.sampling}/${url}`, payload, true);
};

export const allSamples = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.sampling}/${url}`, payload, true);
};

export const allSamplesById = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.sampling}/${url}`, payload, true);
};

export const update = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.sampling}/${url}`, payload, true);
};

export const printSampling = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.sampling}/${url}`, payload, true);
};
